import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';

const StyledAuthLayout = styled('div')(
  () => `
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #EFF4FC;
`,
);

export const AuthLayout: FC = () => (
  <StyledAuthLayout>
    <Outlet />
  </StyledAuthLayout>
);
